import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledRoot = styled.div<{$vh?: number; $isExpanded: boolean}>`
    ${({theme: {palette, spacing, sideBarWidth}, $vh, $isExpanded}) => css`
        width: ${$isExpanded ? sideBarWidth : 112}px;
        height: ${$vh}px;
        background-color: ${palette.primary[950]};
        border-right: 1px solid ${palette.primary[800]};
        padding: ${$isExpanded ? spacing * 8 : spacing * 4}px;
        position: relative;
        transition: width 0.3s ease;
    `}
`
export const StyledMainWrapper = styled.div`
    ${({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: ${spacing}px;
        height: 100%;
        padding: ${spacing * 4}px ${spacing * 4}px 0px;
    `}
`

export const StyledLogo = styled.div`
    ${({theme: {spacing, $isExpanded}}) => css`
        display: flex;
        justify-content: center;
        margin-top: ${$isExpanded ? 0 : spacing * 6}px;

        & img {
            padding-bottom: ${spacing * 6}px;
            width: 110px;
            cursor: pointer;
        }
    `}
`

export const StyledList = styled.div`
    ${({theme: {spacing}}) => css`
        display: grid;
        gap: ${spacing / 2}px;
    `}
`

export const StyledUserInfo = styled.div<{$isExpanded: boolean}>`
    ${({theme: {spacing, palette, typography, truncateText}, $isExpanded}) => css`
        border-top: 1px solid ${palette.primary[800]};
        color: ${palette.primary[200]};
        display: flex;
        justify-content: space-between;
        flex-direction: ${$isExpanded ? 'row' : 'column'};
        align-items: center;
        gap: ${spacing * 3}px;
        margin-top: ${spacing * 6}px;
        padding: ${spacing * 6}px ${$isExpanded ? spacing * 2 : 0}px 0px 0px;
        ${typography.textSm}

        & div {
            ${truncateText};
            max-width: 140px;
            cursor: pointer;
        }
        & svg {
            cursor: pointer;
            fill: ${palette.primary[950]};
        }
        & p {
            font-weight: 600;
            ${truncateText};
            max-width: 154px;
        }
    `}
`

export const StyledContactUsSection = styled(Flexbox)`
    ${({theme: {spacing, palette}}) => css`
        padding-top: ${spacing * 6}px;
        color: ${palette.primary[200]};
    `}
`

export const StyledChevronButton = styled.button<{$isExpanded: boolean}>`
    ${({theme: {palette}}) => css`
        background: none;
        border: none;
        padding: 8px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.3s ease;
        color: ${palette.neutral[100]};
        position: absolute;
        top: 10px;
        right: 10px;

        & svg {
            fill: ${palette.neutral[100]};
        }

        &:hover {
            color: ${palette.primary[300]};
        }
    `}

    transform: ${({$isExpanded}) => (!$isExpanded ? 'rotate(180deg)' : 'rotate(0)')};
`
export const StyledContactUs = styled.div`
    ${() => css`
        cursor: pointer;

        & p {
            text-decoration: underline;
        }
    `}
`
